import { render, staticRenderFns } from "./BillingDelayedScreen.vue?vue&type=template&id=85665f22&scoped=true&"
import script from "./BillingDelayedScreen.vue?vue&type=script&lang=js&"
export * from "./BillingDelayedScreen.vue?vue&type=script&lang=js&"
import style0 from "./BillingDelayedScreen.vue?vue&type=style&index=0&id=85665f22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85665f22",
  null
  
)

export default component.exports